import { useSyncExternalStore } from "react";

/**
 * Whether a Pending QR Orders drawer is open (the header badge's, or the one a
 * prompt's Review opens). While it is, the New QR Order prompts step aside: they
 * sit where the drawer opens, and the drawer lists the same orders with Accept.
 */
let openCount = 0;
const listeners = new Set<() => void>();

const notify = () => listeners.forEach((listener) => listener());

/** Mark a drawer open; call the returned function when it closes. */
export function holdQRPendingPanelOpen(): () => void {
  openCount += 1;
  notify();
  let released = false;
  return () => {
    if (released) return;
    released = true;
    openCount -= 1;
    notify();
  };
}

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export function useQRPendingPanelOpen(): boolean {
  return useSyncExternalStore(subscribe, () => openCount > 0, () => false);
}
